import { render, staticRenderFns } from "./form-checkbox-all.vue?vue&type=template&id=47bbda98&scoped=true"
import script from "./form-checkbox-all.vue?vue&type=script&lang=js"
export * from "./form-checkbox-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbda98",
  null
  
)

export default component.exports